import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import classNames from 'classnames';
import AddPartnerForm from './AddPartnerForm/AddPartnerForm';
import {PartnersList} from './PartnersList/PartnersList';
import {Button, Modal} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import styles from './styles.module.scss';

const PopupManagePartners = () => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const buttonClose = intl.formatMessage({
    id: 'label-button-cancel',
    defaultMessage: 'Cancel',
  });
  const header = intl.formatMessage({
    id: 'partners-popup-manage-partners-header',
    defaultMessage: 'List of partners',
  });

  return (
    <>
      <Button
        className={classNames(styles.buttonEdit, 'btn btn-sm p-0 mb-0')}
        onClick={() => setShow(true)}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Edit_white.svg')}
          alt="edit"
          height={24}
        />
      </Button>
      <Modal
        show={show}
        size={'xl'}
      >
        <Modal.Body>
          <h3 className="card-title font-weight-bold text-dark text-center">
            {header}
          </h3>
          <PartnersList/>
          <AddPartnerForm/>
          <div className="d-flex justify-content-center">
            <Button
              className="btn btn-secondary btn-sm col-2"
              onClick={() => setShow(false)}
            >
              {buttonClose}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupManagePartners;
